import React from "react";
import { Table } from "reactstrap";
import { devTxt, ESTADOS, hhmm } from "../SalidasStatus/statusHelper";

// "Retraso" es el mismo criterio que una quemada (diferencia > tolerancia del punto),
// el backend ya lo cuenta asi en bitacora_resumen.
const dotColor = (cp) => {
  if (cp.tiempo_real == null) return ESTADOS.sin.color;
  return cp.diferencia > cp.tolerancy ? ESTADOS.que.color : ESTADOS.tie.color;
};

const Contador = ({ n, label, estado }) => (
  <div
    style={{
      flex: "1 1 90px",
      background: estado.bg,
      border: `1px solid ${estado.bd}`,
      borderRadius: 8,
      padding: "8px 12px",
    }}
  >
    <div style={{ fontSize: "19px", fontWeight: 700, color: estado.ink }}>{n}</div>
    <div style={{ fontSize: "11.5px", fontWeight: 600, color: estado.ink }}>{label}</div>
  </div>
);

const BitacoraTable = ({ checkpoints = [], resumen, remoteData }) => (
  <div>
    <div className="d-flex align-items-center" style={{ gap: 10 }}>
      <div style={{ fontSize: "15px", fontWeight: 600, flex: 1 }}>Bitácora</div>
      <span style={{ fontSize: "12px", color: "#777a89" }}>{checkpoints.length} checadores</span>
    </div>

    <div className="d-flex flex-wrap" style={{ gap: 8, margin: "12px 0" }}>
      <Contador n={resumen?.a_tiempo ?? 0} label="A tiempo" estado={ESTADOS.tie} />
      <Contador n={resumen?.retraso ?? 0} label="Con retraso" estado={ESTADOS.que} />
      <Contador n={resumen?.sin_dato ?? 0} label="Sin dato" estado={ESTADOS.sin} />
    </div>

    {checkpoints.length === 0 ? (
      <div className="text-center text-muted py-4" style={{ fontSize: "12px" }}>
        {remoteData
          ? "Esta salida recibe su información de un proveedor externo y no tiene bitácora propia."
          : "Esta salida no tiene checadores configurados."}
      </div>
    ) : (
      <Table size="sm" responsive className="mb-0" style={{ fontSize: "12.5px" }}>
        <thead>
          <tr style={{ color: "#777a89" }}>
            <th>Checador</th>
            <th>Programado</th>
            <th>Real</th>
            <th>Dif</th>
            <th>Quemada</th>
            <th>Estancia</th>
            <th>S/B</th>
            <th>Eventos</th>
          </tr>
        </thead>
        <tbody>
          {checkpoints.map((cp) => (
            <tr key={cp.id ?? cp.position} style={{ background: cp.excesos?.length ? "#fff7d9" : undefined }}>
              <td>
                <span
                  style={{
                    display: "inline-block",
                    width: 9,
                    height: 9,
                    borderRadius: "50%",
                    background: dotColor(cp),
                    marginRight: 8,
                  }}
                />
                {cp.nombre}
              </td>
              <td>{hhmm(cp.tiempo_propuesto)}</td>
              <td style={{ fontWeight: 600, color: cp.tiempo_real ? "#272a3a" : "#adb5bd" }}>
                {cp.tiempo_real ? hhmm(cp.tiempo_real) : "s/d"}
              </td>
              <td style={{ color: cp.diferencia > 0 ? ESTADOS.que.ink : ESTADOS.tie.ink }}>
                {cp.diferencia == null ? "—" : devTxt(cp.diferencia)}
              </td>
              <td>
                {cp.tiempo_real == null ? (
                  <span className="text-muted">—</span>
                ) : (
                  <i
                    className={cp.quemadas ? "mdi mdi-check" : "mdi mdi-close"}
                    style={{ color: cp.quemadas ? ESTADOS.que.color : ESTADOS.tie.color }}
                  ></i>
                )}
              </td>
              <td>{cp.estancia == null ? "—" : `${cp.estancia}′`}</td>
              <td>
                {cp.pasaje_in ?? "-"} / {cp.pasaje_out ?? "-"}
              </td>
              <td>
                {!cp.excesos?.length ? (
                  <span className="text-muted">—</span>
                ) : (
                  cp.excesos.map((e, i) => (
                    <div key={i} style={{ fontWeight: 600, color: "#9a7500" }}>
                      Exceso {hhmm(e.fecha)} · {e.kilometros} km/h
                    </div>
                  ))
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    )}
  </div>
);

export default BitacoraTable;
